// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import  defines from '../src/api'
import './permission' // permission control
import InfiniteScroll from 'v-infinite-scroll'
import 'v-infinite-scroll/dist/v-infinite-scroll.css'
import vueclipboard from 'vue-clipboard2'
import Vconsole from 'vconsole'
// new Vconsole()

import vueEsign from 'vue-esign'
Vue.use(vueclipboard)

Vue.use(InfiniteScroll)

Vue.use(vueEsign)
const http = axios.create({
	headers: {
		'Content-Type': 'application/json'
	},
//	timeout: 10000, // 3秒超时
	// withCredentials: true

});

http.defaults.withCredentials = true
Vue.prototype.http = http;

Vue.config.productionTip = false

//vue加载页面 添加title
Vue.directive('title', {
	inserted: function(el, binding) {
		document.title = el.innerText
		el.remove()
	}
})


//全局API变量 挂载到vue原型属性上
Object.keys(defines).forEach((key)=>{
    Vue.prototype[key] = defines[key];
})
/* eslint-disable no-new */
new Vue({
	el: '#app',
	router,
	components: {
		App
	},
	template: '<App/>'
})


const debug = process.env.NODE_ENV !== 'production';
//线上代码关闭log
let log  = window.console.log;
// window.console.log = function(){
// if(debug){
//     log.apply(window,[].slice.call(arguments));
// }
// };



// WEBPACK FOOTER //
// ./src/main.js